<ng-container *ngIf="ingredientTreeview && ingredientTreeview.length > 0; else noCaraBlock">
    <lib-np-treeview-item [treeviewData]="ingredientTreeview" [caracConfig]="caracConfig.ConfigurationObject"></lib-np-treeview-item>
</ng-container>
<ng-template #noCaraBlock>
    <div  class="noCaraText">Aucune information trouvée !</div>
</ng-template>


